import { useMemo } from 'react'
import { DatesType } from './types'

type UseModifies = {
  dates: DatesType
  enteredTo: Date | undefined
}

export const useModifies = ({ dates, enteredTo }: UseModifies) => {
  return useMemo(() => {
    const { from, to } = dates
    if (from && to) return { start: from, end: to }
    if (enteredTo && from) {
      if (enteredTo < from) {
        return { start: enteredTo, end: from }
      }
      if (enteredTo > from) {
        return { start: from, end: enteredTo }
      }
    }
  }, [dates, enteredTo])
}
